import React, { createContext, useEffect, useState } from 'react';

import { changeLanguage, getLanguage, initLanguages } from '../utils/translation.utils';
export const LanguageContext = createContext();

export default function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(getLanguage);

  useEffect(() => {
    initLanguages();
  }, []);

  function onLanguageChange(newLanguage) {
    setLanguage(newLanguage);
    changeLanguage(newLanguage);
  }

  return <LanguageContext.Provider value={[language, onLanguageChange]}>{children}</LanguageContext.Provider>;
}
